import { ResponsiveFloraTypography } from 'components';
import { getFormattedZipcode, capitalizeFirstLetter, isMobile as isMobileHelper } from 'helpers';

import type { ChangeRequestAddress } from 'domains/change-cadastral';

export type AddressRegistrationProps = {
  data?: ChangeRequestAddress;
};

export const AddressFormatted = ({ data }: AddressRegistrationProps) => {
  const isMobile = isMobileHelper();
  const address = `${data?.address}, ${data?.number}, ${data?.complement}`;
  const formattedAddress = capitalizeFirstLetter(address);
  const formattedDistrict = capitalizeFirstLetter(data?.district ?? '');
  const formattedCity = capitalizeFirstLetter(data?.city ?? '');
  const formattedCep = `CEP ${getFormattedZipcode(data?.zipcode)}`;

  if (!data) {
    return null;
  }

  if (isMobile) {
    return (
      <ResponsiveFloraTypography>
        {formattedAddress}
        <br />
        {formattedDistrict}
        <br />
        {formattedCity} - {data?.state}
        <br />
        {formattedCep}
      </ResponsiveFloraTypography>
    );
  }

  return (
    <ResponsiveFloraTypography>
      {`${formattedAddress}, ${formattedDistrict}, ${formattedCity} - ${data?.state}, ${formattedCep}`}
    </ResponsiveFloraTypography>
  );
};
